import { CANVAS_THRESHOLDS } from '../utils/pageCanvas';

export type CanvasThreshold = (typeof CANVAS_THRESHOLDS)[number];

/**
 * "The page canvas is at most N wide", for a styled-component.
 *
 * The Tailwind side of the app gets real container queries; styled-components v5 cannot — its
 * stylis v3 compiles `@container` with the selector stripped, so the rule is invalid and the
 * browser drops it without a word. A token published on <html> is the readout that does work,
 * and unlike `@media` it counts the drawer's strip against the page.
 */
export function canvasAtMost(threshold: CanvasThreshold): string {
  return `html[data-canvas~='lte-${threshold}'] &`;
}
